module.exports = __webpack_public_path__ + "media/images/views/candidate/request/primary-block-c142db1926c55daff8759c2cdc92bbc3.png";